import { gql } from "@apollo/client";

const PLATFORM_FEDERATIONS = gql`
  query platformsFedrations($page: Int, $limit: Int, $filter: ListPlatformInput) {
    platformsFedrations(page: $page, limit: $limit, filter: $filter) {
      organizations {
        federation {
          organizationName
          id
          publicId
        }
      }
    }
  }
`;

export default PLATFORM_FEDERATIONS;
